export default __webpack_public_path__ + "static/media/regulatory--parking-restrictions--g3.4e6ef760.png";